import { render } from "./Cinematic.vue?vue&type=template&id=48a8ebd4"
import script from "./Cinematic.vue?vue&type=script&lang=js"
export * from "./Cinematic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__